import { mapCouponType } from '@/utils/coupon-helper';
import { CouponActInfoWithGoodsAndState } from '@tencent/wphk-act-base-framework';
import { CouponButtonType, CouponInfo, DetailButtonType } from '@tencent/wphk-act-base-ui';
import { useExchInfo } from '../../../../hooks/use-exch-info';
import { COUPON_STAMP_TEXT, DETAIL_DIALOG_BTN_TEXT } from '@/config/coupon-config';
import { ExchButtonStatus } from '@/types/exch-info';

// TODO: 应该放在wphk-act-base-components里，券详情弹窗内置处理
const getIsShowBtn = (buttonStatus: ExchButtonStatus) => buttonStatus !== ExchButtonStatus.Hidden;
const getIsDisabled = (buttonStatus: ExchButtonStatus) => [
  ExchButtonStatus.IsLocked, ExchButtonStatus.IsLimit,
].includes(buttonStatus);
const getDetailButtonType = ({ buttonStatus, isDisabled }: { buttonStatus: ExchButtonStatus, isDisabled: boolean }) => {
  if (buttonStatus === ExchButtonStatus.ToUse) {
    return DetailButtonType.ghost;
  }
  if (isDisabled) {
    return DetailButtonType.outofperiod;
  }
  return DetailButtonType.primary;
};
const getBtnBottomInfo = ({ buttonStatus }:
{ buttonStatus: ExchButtonStatus  }) => {
  if (buttonStatus === ExchButtonStatus.IsLimit) {
    return '今日已搶完';
  }
};

const getButtonType = (buttonStatus: ExchButtonStatus) => {
  switch (buttonStatus) {
    case ExchButtonStatus.IsLimit:
      return CouponButtonType.disabled;
    case ExchButtonStatus.ToUse:
      return CouponButtonType.weaken;
    case ExchButtonStatus.ToReceive:
      return CouponButtonType.default;
  }
};

// 券面额外信息（覆盖couponInfo的）
const getCouponExtraInfo = (
  buttonStatus: ExchButtonStatus,
  couponInfo: CouponActInfoWithGoodsAndState,
): CouponInfo => ({
  // 优惠券名称和描述（本身不用动的，但在CouponInfo中是必填项)
  prizeName: couponInfo?.couponName ?? '',
  prizeDesc: couponInfo?.couponDesc ?? '',

  // 将原始couponType转为UI的couponType
  couponType: mapCouponType(couponInfo?.couponType),
  // // 左上角标签
  isShowButton: [
    ExchButtonStatus.ToReceive,
    ExchButtonStatus.ToUse,
    ExchButtonStatus.IsLimit].includes(buttonStatus),
  isExpire: false,
  buttonType: getButtonType(buttonStatus),
  tipsTextRight: buttonStatus === ExchButtonStatus.IsLimit ? '今日已搶完' : '',
});

export const useExchUIInfo = ({ exchInfo, extraInfo }:
{exchInfo: CouponActInfoWithGoodsAndState, extraInfo?: {isLocked?: boolean, isToReceive?: boolean}}) => {
  const { exchButtonStatus } = useExchInfo({ exchInfo, extraInfo });
  const isDisabled = getIsDisabled(exchButtonStatus);
  const couponDetailExtraInfo = {
    stampText: COUPON_STAMP_TEXT[exchInfo.couponState!],
    isExpire: exchButtonStatus === ExchButtonStatus.Hidden,
  };

  const res =  {
    /** 外显券信息 */
    couponExtraInfo: getCouponExtraInfo(exchButtonStatus, exchInfo),
    /** 券详情弹层信息 */
    detailDialog: {
      couponDetailExtraInfo,
      btnBottomInfo: getBtnBottomInfo({ buttonStatus: exchButtonStatus }),
      couponDetailBtn: {
        isShowBtn: getIsShowBtn(exchButtonStatus),
        isDisabled,
        btnText: DETAIL_DIALOG_BTN_TEXT[exchButtonStatus],
        type: getDetailButtonType({ isDisabled, buttonStatus: exchButtonStatus }),
      },
    },
  };
  console.log('===useExchUIInfo', exchButtonStatus, res);
  return res;
};
